<template lang="pug">
.div
  //Orders
  .d-flex(class='justify-end')
    CreateOrderModal(
      data-model= 'order'
      :data-subsidaries = 'dataSubsidaries'
      :dataSubsidarySelected = 'dataSubsidarySelected'
      :data-item-kinds= 'dataItemKinds'
      :data-options-maintenance-kinds= 'dataOptionsMaintenanceKinds'
      :data-options-maintenance-complement-kinds= 'dataOptionsMaintenanceComplementKinds'
      :data-options-orderable-kinds= 'dataOptionsOrderableKinds'
    )
  
  //- Leyenda de colores
  .tw-flex.tw-gap-4.tw-mb-3.tw-text-xs.tw-text-gray-600(v-if='!emptyItems')
    span
      i.fa-solid.fa-circle.tw-text-yellow-500.tw-mr-1
      | Pending
    span
      i.fa-solid.fa-circle.tw-text-blue-500.tw-mr-1
      | Scheduled
    span
      i.fa-solid.fa-circle.tw-text-green-500.tw-mr-1
      | Completed
    span
      i.fa-solid.fa-circle.tw-text-red-500.tw-mr-1
      | Canceled
    
  table(v-if='!emptyItems' class="table table-hover orders-timeline-table no-sticky-override")
    thead
      tr
        th.tw-bg-gray-50(colspan="4") 
        th.tw-bg-blue-50.tw-text-center(colspan="3") Order Info
        th.tw-bg-amber-50.tw-text-center(colspan="4") 
          i.fa-solid.fa-calendar-days.tw-mr-1
          | Timeline
        th.tw-bg-green-50.tw-text-center(colspan="2") Billing
        th.tw-bg-gray-50.tw-text-center Actions
      tr.tw-text-xs
        th.tw-text-gray-500 #
        th ID
        th WO-PO
        th.tw-text-center Status
        //- Order Info
        th.tw-bg-blue-50.tw-border-l Service
        th.tw-bg-blue-50 Freq.
        th.tw-bg-blue-50.tw-border-r Price
        //- Timeline - con iconos
        th.tw-bg-amber-50.tw-border-l
          i.fa-solid.fa-backward-step.tw-mr-1.tw-text-gray-400(title="Previous Cleaning")
          | Previous
        th.tw-bg-amber-50
          i.fa-solid.fa-flag.tw-mr-1.tw-text-orange-400(title="Due On")
          | Due
        th.tw-bg-amber-50
          i.fa-solid.fa-calendar-check.tw-mr-1.tw-text-blue-400(title="Scheduled For")
          | Scheduled
        th.tw-bg-amber-50.tw-border-r
          i.fa-solid.fa-forward-step.tw-mr-1.tw-text-green-400(title="Next Cleaning")
          | Next
        //- Billing
        th.tw-bg-green-50.tw-border-l Invoice
        th.tw-bg-green-50.tw-border-r Payment
        //- Actions
        th.tw-text-center
          i.fa-solid.fa-ellipsis-vertical
    tbody
      //- Separador visual entre órdenes activas y completadas
      template(v-for="(item, index) in items")
        tr.tw-bg-gray-200.tw-text-xs.tw-text-gray-500(v-if="index > 0 && isActiveOrder(items[index-1]) && !isActiveOrder(item)" :key="'sep-'+item.id")
          td.tw-py-1.tw-text-center(colspan="14")
            i.fa-solid.fa-clock-rotate-left.tw-mr-1
            | History
        tr(:class="getRowClass(item)" :key="item.id")
          //- Número de secuencia
          td.tw-text-gray-400.tw-text-xs {{index + 1}}
          //- ID con link
          td
            a.tw-font-medium(:href="order_path(item.id)" target="_blank" :class="getTextClassItem(item)")
              | {{item.id}}
          td(:class="getTextClassItem(item)") {{item.job_number}}
          //- Status con badge
          td.tw-text-center
            span.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-font-medium(:class="getStatusBadgeClass(item)")
              i(:class="getStatusIcon(item)")
              |  {{item.state.name}}
          //- Order Info
          td.tw-bg-blue-50.tw-bg-opacity-30.tw-border-l(:class="getTextClassItem(item)") {{item.service_item==null ? "" : item.service_item.service}}
          td.tw-bg-blue-50.tw-bg-opacity-30.tw-text-center(:class="getTextClassItem(item)") 
            span.tw-text-xs {{item.frequency_month=="" || item.frequency_month==null ? item.frequency+'d' : item.frequency_month+'mo'}}
          td.tw-bg-blue-50.tw-bg-opacity-30.tw-border-r.tw-font-medium(:class="getTextClassItem(item)") ${{(item.price*100/100).toFixed(2)}}
          //- Timeline
          td.tw-bg-amber-50.tw-bg-opacity-30.tw-border-l.tw-text-gray-500.tw-text-xs {{item.previous_cleaning_date}}
          td.tw-bg-amber-50.tw-bg-opacity-30(:class="getDueDateClass(item)")
            span.tw-font-medium(v-if="item.locale_due_at")
              i.fa-solid.fa-flag.tw-mr-1.tw-text-xs(v-if="isOverdue(item)")
              | {{item.locale_due_at}}
          td.tw-bg-amber-50.tw-bg-opacity-30(:class="getScheduledClass(item)")
            span.tw-font-medium(v-if="item.locale_schedule_for")
              i.fa-solid.fa-calendar-check.tw-mr-1.tw-text-xs
              | {{item.locale_schedule_for}}
            span.tw-text-gray-300.tw-italic.tw-text-xs(v-else-if="isActiveOrder(item)") not scheduled
          td.tw-bg-amber-50.tw-bg-opacity-30.tw-border-r
            //- Para órdenes completadas mostrar "Done → Next"
            template(v-if="item.locale_completed_at")
              span.tw-text-green-600.tw-text-xs
                i.fa-solid.fa-check.tw-mr-1
                | {{item.locale_completed_at}}
              span.tw-text-gray-400.tw-mx-1 →
              span.tw-text-blue-600.tw-text-xs {{item.next_cleaning_date}}
            template(v-else-if="item.next_cleaning_date")
              span.tw-text-blue-600 {{item.next_cleaning_date}}
          //- Billing
          td.tw-bg-green-50.tw-bg-opacity-30.tw-border-l
            template(v-if="item.invoices.length > 0")
              app-icon-link(
                v-for="(inv, idx) in item.invoices",
                :key="idx",
                data-kind="link",
                :href="invoice_path(inv.invoice_id)",
                data-target="_blank",
                data-icon="fa-solid fa-file-invoice",
                data-style="display: inline-block;",
                :data-label="inv.invoice_id",
                :data-title="$I18n.t('vue.orders_detail_table_panel.view_invoice') + ' ' + inv.invoice_id"
              )
            span.tw-text-gray-300.tw-text-xs(v-else-if="isActiveOrder(item)") -
          td.tw-bg-green-50.tw-bg-opacity-30.tw-border-r(:class="getPaymentStatusClass(item)")
            span.tw-text-xs(v-if="item.invoices.length > 0") {{ item.invoices.map(function(i) { return i.status }).filter(function(value, index, self) { return self.indexOf(value) === index; }).join(', ') }}
          //- Actions
          td.tw-text-center
            .app-buttons-row.justify-center
              app-icon-link(
                data-kind="link",
                :href="order_path(item.id)"
                data-target="_blank"
                data-icon="fa-solid fa-eye",
                data-label="",
                :data-title="$I18n.t('vue.orders_detail_table_panel.view_order')"
              )
  div(v-if='!emptyItems')
    .row
      .col-9
      .col-3
        .row
          table(class="table table-bordered table-hover")
            tbody
              tr(v-if="total_amount_orders")
                th.d-flex(class='justify-end')  {{$I18n.t('vue.orders_detail_table_panel.total_orders')}}
                th(class="text-dark") {{total_amount_orders}}
              tr(v-if="total_amount_billed")
                th.d-flex(class='justify-end')  {{$I18n.t('vue.orders_detail_table_panel.total_billed')}}
                th(class="text-success") {{total_amount_billed}}
              tr(v-if="total_amount_unbilled")
                th.d-flex(class='justify-end')  {{$I18n.t('vue.orders_detail_table_panel.total_unbilled')}}
                th(class="text-danger")  {{total_amount_unbilled}}

  div
    p(v-if='emptyItems' class='message-search') {{$I18n.t('vue.orders_detail_table_panel.empty_items')}}

</template>
<script>
import CoreComponents from "../core";
import CreateOrderModal from './create-order-modal.vue'
import StickyTableMixin from '../../mixins/sticky_table_mixin.js';
const { BackendRoutes } = require("app/services");
export default {
  mixins: [StickyTableMixin],
  components:{
    "app-icon-link": CoreComponents.AppIconLink,
    CreateOrderModal,
  },
  props:{
    dataItems: String,
    dataModel: String,
    dataSubsidaries: String,
    dataSubsidarySelected: String,
    dataItemKinds: String,
    dataOptionsMaintenanceKinds: String,
    dataOptionsMaintenanceComplementKinds: String,
    dataOptionsOrderableKinds: String,
    dataTotales: String,
  },
  data: function(){
    return {
      record:{
      },
      items: this.sortOrders(JSON.parse(this.dataItems)),
      total_amount_orders: (!this.dataTotales || /^\s*$/.test(this.dataTotales)) ? "" : JSON.parse(this.dataTotales).total_orders,
      total_amount_billed: (!this.dataTotales || /^\s*$/.test(this.dataTotales)) ? "" : JSON.parse(this.dataTotales).billed,
      total_amount_unbilled: (!this.dataTotales || /^\s*$/.test(this.dataTotales)) ? "" : JSON.parse(this.dataTotales).unbilled,
      labels:{
      }
    }
  },
  computed:{
    emptyItems: function(){
      return this.items.length === 0;
    }
  },
  methods:{
    sortOrders: function(orders) {
      // Ordenar órdenes: primero REGISTERED y SCHEDULED, luego por schedule_for o due_at
      return orders.sort((a, b) => {
        const activeStatuses = ["REGISTERED", "SCHEDULED"];
        const aIsActive = activeStatuses.includes(a.state.name);
        const bIsActive = activeStatuses.includes(b.state.name);
        
        // Primero las órdenes activas (REGISTERED, SCHEDULED)
        if (aIsActive && !bIsActive) return -1;
        if (!aIsActive && bIsActive) return 1;
        
        // Obtener fecha de ordenamiento: schedule_for si existe, sino due_at
        const getOrderDate = (order) => {
          // Usar schedule_for si existe, sino due_at
          const dateStr = order.schedule_for || order.due_at;
          return dateStr ? new Date(dateStr) : new Date(0);
        };
        
        const dateA = getOrderDate(a);
        const dateB = getOrderDate(b);
        
        // Para órdenes activas: ordenar por fecha ascendente (próximas primero)
        // Para órdenes completadas: ordenar por fecha descendente (más recientes primero)
        if (aIsActive && bIsActive) {
          return dateA - dateB; // Ascendente para activas
        }
        return dateB - dateA; // Descendente para completadas
      });
    },
    isActiveOrder: function(item) {
      if (!item) return false;
      return ["REGISTERED", "SCHEDULED"].includes(item.state.name);
    },
    isOverdue: function(item) {
      if (!item.due_at || !this.isActiveOrder(item)) return false;
      return new Date(item.due_at) < new Date();
    },
    getStatusBadgeClass: function(item) {
      const status = item.state.name;
      switch(status) {
        case "REGISTERED": return "tw-bg-yellow-100 tw-text-yellow-800";
        case "SCHEDULED": return "tw-bg-blue-100 tw-text-blue-800";
        case "COMPLETED": return "tw-bg-green-100 tw-text-green-800";
        case "CANCELED": return "tw-bg-red-100 tw-text-red-800";
        default: return "tw-bg-gray-100 tw-text-gray-800";
      }
    },
    getStatusIcon: function(item) {
      const status = item.state.name;
      switch(status) {
        case "REGISTERED": return "fa-solid fa-clock";
        case "SCHEDULED": return "fa-solid fa-calendar-check";
        case "COMPLETED": return "fa-solid fa-check";
        case "CANCELED": return "fa-solid fa-xmark";
        default: return "";
      }
    },
    getDueDateClass: function(item) {
      if (!this.isActiveOrder(item)) return "tw-text-gray-500 tw-text-xs";
      if (this.isOverdue(item)) return "tw-text-red-600 tw-font-bold";
      return "tw-text-orange-600";
    },
    getScheduledClass: function(item) {
      if (!this.isActiveOrder(item)) return "tw-text-gray-500 tw-text-xs";
      if (item.locale_schedule_for) return "tw-text-blue-600";
      return "";
    },
    getPaymentStatusClass: function(item) {
      const statuses = item.invoices.map(i => i.status);
      if (statuses.includes("PAID")) return "tw-text-green-600 tw-font-medium";
      if (statuses.includes("PENDING")) return "tw-text-orange-600";
      return "";
    },
    getRowClass: function(item) {
      let status = item.state.name;
      // Resaltar órdenes activas (REGISTERED o SCHEDULED) con fondo amarillo suave
      if (status === "REGISTERED" || status === "SCHEDULED") {
        return "tw-bg-yellow-50";
      }
      return "";
    },
    getTextClassItem: function (item) {
      let status = item.state.name;
      let result = "";
      if (status == "CANCELED"){
        result = "text-danger";
      }
      if (status == "COMPLETED"){
        result = "text-success";
      }
      if (status == "SCHEDULED"){
        result = "text-info";
      }
      return result;
    },
    retrievenotes:function(){
      location.reload();
    },
    order_path: function (order_id) {
      return BackendRoutes.order_path(order_id);
    },
    invoice_path: function (invoice_id) {
      return BackendRoutes.invoice_path(invoice_id);
    }
  }
}
</script>

<style scoped>
.orders-timeline-table {
  font-size: 0.85rem;
  min-width: 1200px; /* Ancho mínimo para evitar que se amontone */
  table-layout: auto;
}

.orders-timeline-table thead th {
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.5rem 0.75rem;
}

.orders-timeline-table tbody td {
  vertical-align: middle;
  padding: 0.4rem 0.6rem;
  white-space: nowrap; /* Evitar que el texto se parta */
}

/* Bordes para separar secciones */
.tw-border-l {
  border-left: 2px solid rgba(0,0,0,0.1) !important;
}

.tw-border-r {
  border-right: 2px solid rgba(0,0,0,0.1) !important;
}

/* Fondo más sutil para las secciones */
.tw-bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}
</style>
